export default __webpack_public_path__ + "static/media/logo_makansafe_sm.81a742b8.png";